module.exports = __webpack_public_path__ + "img/palabras-wgmi-triangles-preview.0dfb1a58.png";